import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

/** Confirmation before removing an announcement from every staff member's Dashboard. */
export function DeletePostDialog({ open, onOpenChange, onConfirmYes, postTitle, inProgress = false }) {
  const title = String(postTitle || "").trim();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn("gap-0 overflow-hidden p-0 sm:max-w-md", "border-border/80 shadow-lg")}>
        <div className="border-b border-border/60 bg-muted/30 px-6 pb-4 pt-6">
          <DialogHeader className="space-y-4 text-left">
            <div
              className="flex h-12 w-12 items-center justify-center rounded-2xl bg-destructive/15 text-destructive ring-1 ring-destructive/20 dark:bg-destructive/10 dark:ring-destructive/25"
              aria-hidden
            >
              <Trash2 className="h-6 w-6" strokeWidth={2.25} />
            </div>
            <div className="space-y-1.5">
              <DialogTitle className="text-xl font-semibold tracking-tight">Delete announcement?</DialogTitle>
              <DialogDescription className="text-[15px] leading-relaxed text-muted-foreground">
                {title ? (
                  <>
                    Removes <span className="font-medium text-foreground">{title}</span> from every staff
                    member&apos;s Dashboard.
                  </>
                ) : (
                  <>Removes this announcement from every staff member&apos;s Dashboard.</>
                )}
              </DialogDescription>
            </div>
          </DialogHeader>
        </div>
        <DialogFooter className="flex flex-row items-center justify-end gap-2 border-t border-border/60 bg-background px-6 py-4 sm:justify-end">
          <Button
            type="button"
            variant="outline"
            className="min-w-18"
            disabled={inProgress}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            className="min-w-18"
            disabled={inProgress}
            onClick={() => {
              void onConfirmYes();
            }}
          >
            {inProgress ? "Deleting…" : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
